import axios from "axios";

export default {
    state: {
        course: null,
        config: null
    },
    actions: {
        async fetchCourse({ commit }) {
            try {
                const response = await axios.get("service/market-course");
                commit("SET_COURSE", response.data);
            } catch (e) {
                console.error(e);
            }
        },
        async fetchConfig({ commit }) {
            try {
                const response = await axios.get("config");
                commit("SET_CONFIG", response.data);
            } catch (e) {
                console.error(e);
            }
        }
    },
    mutations: {
        SET_COURSE(state, course) {
            state.course = course;
        },
        SET_CONFIG(state, config) {
            state.config = config;
        }
    },
    getters: {
        getCourse(state) {
            return state.course;
        },
        getConfig(state) {
            return state.config;
        }
    }
};
